import ActivityCard from "./ActivityCard";

export default function ActivityGrid({ activities, minPriceMap, baseUrl, onActivityClick }) {
  if (!activities?.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        No activities found. Try another city.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 min-[481px]:grid-cols-2 min-[769px]:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
      {activities.map((activity, idx) => (
        <ActivityCard
          key={activity._id}
          activity={activity}
          minPrice={minPriceMap?.[activity._id]}
          badgeIndex={idx}
          baseUrl={baseUrl}
          onClick={() => onActivityClick?.(activity)}
        />
      ))}
    </div>
  );
}
